import { createAction } from "@reduxjs/toolkit"

import { AUTH_SLICE_NAME } from "./auth.constants"

// Plain actions shared between auth.thunks.js (dispatches them mid-flow, mirroring
// what the legacy saga did with `yield put(AuthActions.x(...))`) and auth.slice.js
// (reacts to them via `extraReducers`). Kept in their own file so neither of those
// two files needs to import the other — thunks.js already imports slice.js's async
// thunks for `pending` cases, so the reverse edge would be a circular dependency.
export const signInSuccess = createAction(`${AUTH_SLICE_NAME}/signInSuccess`)
export const signInFailure = createAction(`${AUTH_SLICE_NAME}/signInFailure`)
export const checkEmailInitSuccess = createAction(`${AUTH_SLICE_NAME}/checkEmailInitSuccess`)
export const verify2FAFailure = createAction(`${AUTH_SLICE_NAME}/verify2FAFailure`)
export const generate2FASetupSuccess = createAction(`${AUTH_SLICE_NAME}/generate2FASetupSuccess`)
export const generate2FASetupFailure = createAction(`${AUTH_SLICE_NAME}/generate2FASetupFailure`)
export const confirm2FASetupSuccess = createAction(`${AUTH_SLICE_NAME}/confirm2FASetupSuccess`)
export const confirm2FASetupFailure = createAction(`${AUTH_SLICE_NAME}/confirm2FASetupFailure`)
export const generateAdminSecurity2FASuccess = createAction(
  `${AUTH_SLICE_NAME}/generateAdminSecurity2FASuccess`
)
export const generateAdminSecurity2FAFailure = createAction(
  `${AUTH_SLICE_NAME}/generateAdminSecurity2FAFailure`
)
export const confirmAdminSecurity2FASuccess = createAction(
  `${AUTH_SLICE_NAME}/confirmAdminSecurity2FASuccess`
)
export const confirmAdminSecurity2FAFailure = createAction(
  `${AUTH_SLICE_NAME}/confirmAdminSecurity2FAFailure`
)
export const commitAdminSecurity2FASuccess = createAction(
  `${AUTH_SLICE_NAME}/commitAdminSecurity2FASuccess`
)
export const commitAdminSecurity2FAFailure = createAction(
  `${AUTH_SLICE_NAME}/commitAdminSecurity2FAFailure`
)
export const acceptAdminInviteSuccess = createAction(`${AUTH_SLICE_NAME}/acceptAdminInviteSuccess`)
export const acceptAdminInviteFailure = createAction(`${AUTH_SLICE_NAME}/acceptAdminInviteFailure`)
export const createAccountSuccess = createAction(`${AUTH_SLICE_NAME}/createAccountSuccess`)
export const createAccountFailure = createAction(`${AUTH_SLICE_NAME}/createAccountFailure`)
export const sendConfirmEmailSuccess = createAction(`${AUTH_SLICE_NAME}/sendConfirmEmailSuccess`)
export const sendConfirmEmailFailure = createAction(`${AUTH_SLICE_NAME}/sendConfirmEmailFailure`)
export const updateProfile = createAction(`${AUTH_SLICE_NAME}/updateProfile`)
export const clearState = createAction(`${AUTH_SLICE_NAME}/clearState`)
export const signUpSuccess = createAction(`${AUTH_SLICE_NAME}/signUpSuccess`)
export const signUpFailure = createAction(`${AUTH_SLICE_NAME}/signUpFailure`)
export const socialAuthReset = createAction(`${AUTH_SLICE_NAME}/socialAuthReset`)
export const socialAuthFailure = createAction(`${AUTH_SLICE_NAME}/socialAuthFailure`)
export const socialAuthSuccess = createAction(`${AUTH_SLICE_NAME}/socialAuthSuccess`)
export const socialAuthDeleteSuccess = createAction(`${AUTH_SLICE_NAME}/socialAuthDeleteSuccess`)
export const updateTokens = createAction(`${AUTH_SLICE_NAME}/updateTokens`)
export const authFetchingReset = createAction(`${AUTH_SLICE_NAME}/authFetchingReset`)
export const refreshTokenSuccess = createAction(`${AUTH_SLICE_NAME}/refreshTokenSuccess`)
export const refreshTokenFailure = createAction(`${AUTH_SLICE_NAME}/refreshTokenFailure`)
export const verifyTokenSuccess = createAction(`${AUTH_SLICE_NAME}/verifyTokenSuccess`)
export const verifyTokenFailure = createAction(`${AUTH_SLICE_NAME}/verifyTokenFailure`)
export const changeAdminPasswordSuccess = createAction(
  `${AUTH_SLICE_NAME}/changeAdminPasswordSuccess`
)
export const changeAdminPasswordFailure = createAction(
  `${AUTH_SLICE_NAME}/changeAdminPasswordFailure`
)
export const authSetProp = createAction(`${AUTH_SLICE_NAME}/authSetProp`)
export const authErrorReset = createAction(`${AUTH_SLICE_NAME}/authErrorReset`)
export const setShowModalPremiumFeatures = createAction(
  `${AUTH_SLICE_NAME}/setShowModalPremiumFeatures`
)

// Shared logout action for all slices

export const logout = createAction(`LOGOUT`)
